import React, { Suspense, useCallback } from 'react';
import { Switch } from 'react-router-dom';
import { buildPath } from 'react-structure-admin';
import generateUUID from 'util/functions/generateUUID';
import RestrictedRoute from './RestrictedRoute';
import RouteRedirect from './RouteRedirect';
import SimpleRoute from './SimpleRoute';

const WrappedRoute = (props) => {
  const { route, isContainer, onBeforeRouteRender } = props;
  const { roles = [], features = [] } = route;
  let { basePath } = props;

  basePath = buildPath(basePath, route.path);

  const renderRoute = (routeProps) => {
    if (onBeforeRouteRender) {
      const result = onBeforeRouteRender({ basePath, route, routeProps });

      if (result) {
        return result;
      }
    }

    return <route.component {...route} basePath={basePath} {...routeProps} />;
  };

  const isContainerAux = route.isContainer ?? isContainer;

  if (route.redirectTo) {
    return (
      <SimpleRoute
        basePath={basePath}
        route={route}
        render={() => <RouteRedirect to={route.redirectTo} />}
      />
    );
  }

  return (
    <>
      {(roles && roles.length > 0) || (features && features.length > 0) ? (
        <RestrictedRoute
          features={features}
          roles={roles}
          key={basePath}
          exact={route.exact || false}
          path={`${basePath}`}
          render={renderRoute}
        />
      ) : (
        <SimpleRoute basePath={basePath} route={route} render={renderRoute} />
      )}
      {isContainerAux && route.routes && (
        <Routes
          key={`container_${basePath}`}
          routes={route.routes}
          roles={route.roles || roles}
          basePath={basePath}
          isContainer={isContainerAux}
          onBeforeRouteRender={onBeforeRouteRender}
        />
      )}
    </>
  );
};

const Routes = ({
  routes = [],
  roles = [],
  basePath = '',
  isContainer,
  onBeforeRouteRender
}) => {
  return (
    <Switch>
      <Suspense fallback={<div>Carregando...</div>}>
        {routes.map((route) => (
          <WrappedRoute
            key={generateUUID()}
            route={route}
            roles={roles}
            basePath={basePath}
            isContainer={isContainer}
            onBeforeRouteRender={onBeforeRouteRender}
          />
        ))}
      </Suspense>
    </Switch>
  );
};

export default Routes;
